import { type HeaderGroup, type Row, type RowData, type Table } from "@tanstack/react-table";

export type TableGroup = "center" | "left" | "right";

export function getTableHeaderGroups<T extends RowData>(
	table: Table<T>,
	tableGroup?: TableGroup
): [HeaderGroup<T>[], HeaderGroup<T>[]] {
	if (tableGroup === "left") {
		return [table.getLeftHeaderGroups(), table.getLeftFooterGroups()];
	}

	if (tableGroup === "right") {
		return [table.getRightHeaderGroups(), table.getRightFooterGroups()];
	}

	if (tableGroup === "center") {
		return [table.getCenterHeaderGroups(), table.getCenterFooterGroups()];
	}

	return [table.getHeaderGroups(), table.getFooterGroups()];
}

export function getRowGroup<T extends RowData>(row: Row<T>, tableGroup?: TableGroup) {
	if (tableGroup === "left") {
		return row.getLeftVisibleCells();
	}
	if (tableGroup === "right") {
		return row.getRightVisibleCells();
	}
	if (tableGroup === "center") {
		return row.getCenterVisibleCells();
	}
	return row.getVisibleCells();
}
